import View from './view.js'
import React from 'react'
import useCapture from '../useCapture.js'

export default React.forwardRef(function Logic(props, ref) {
  let { onKeyUp, onChange } = useCapture(props)
  return (
    <View
      {...props}
      onKeyUp={onKeyUp}
      onChange={onChange}
      innerRef={ref}
      isShowingInvalidMessage={
        props.isInvalid &&
        typeof props.invalidMessage === 'string' &&
        props.invalidMessage !== ''
      }
      value={typeof props.value === 'number' ? props.value : props.value || ''}
    />
  )
})
